import { render } from "./InitialDownloadsModal.vue?vue&type=template&id=cc21c792&scoped=true"
import script from "./InitialDownloadsModal.vue?vue&type=script&lang=js"
export * from "./InitialDownloadsModal.vue?vue&type=script&lang=js"

import "./InitialDownloadsModal.vue?vue&type=style&index=0&id=cc21c792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc21c792"]])

export default __exports__